import createHistory from 'history/createHashHistory';

const history = createHistory({
  baseName: process.env.PUBLIC_URL,
  initialIndex: 0
});

export default history;
